var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.999L9 11.999M12 14.999C13.3968 14.4678 14.7369 13.7977 16 12.999M12 14.999V19.999C12 19.999 15.03 19.449 16 17.999C17.08 16.379 16 12.999 16 12.999M9 11.999C9.53214 10.6185 10.2022 9.29509 11 8.04903C12.1652 6.18601 13.7876 4.65208 15.713 3.59312C17.6384 2.53416 19.8027 1.9854 22 1.99903C22 4.71903 21.22 9.49903 16 12.999M9 11.999H4C4 11.999 4.55 8.96903 6 7.99903C7.62 6.91903 11 7.99903 11 7.99903M4.5 16.499C3 17.759 2.5 21.499 2.5 21.499C2.5 21.499 6.24 20.999 7.5 19.499C8.21 18.659 8.2 17.369 7.41 16.589C7.02131 16.218 6.50929 16.0037 5.97223 15.9871C5.43516 15.9704 4.91088 16.1528 4.5 16.499Z",
    stroke: "#7B5EED",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.f730afd7877d16820370d4b3e4e87433.svg";
export { ForwardRef as ReactComponent };